import cls from 'classnames'
import React, { useState } from 'react'
import styles from './style.module.less'

interface Props {
  children?: React.ReactNode
  title: string
  description?: string
  onChange?: (val: boolean) => void
  visible?: boolean
  style?: React.CSSProperties
  width?: number | string
}

const GuideDrawer = (props: Props) => {
  const { children, title, description, onChange, visible,style, width } = props

  const [show, setShow] = useState(true)


  return (
    <div className={cls({
      [styles.guideDrawer]: true,
      [styles.guideDrawerShow]: (visible ?? show) ? true : false
    })} style={{ right: (visible ?? show) ? '0' : -(width ?? 340), width, ...style }}>
      <div className={styles.content}>
        <div className={styles.title}>
          {title}
          <span className={styles.desc}>{description}</span>
        </div>
        <div className={styles.text}>{children}</div>
        <div
          onClick={() => {
            if(visible == null) {
              setShow(!show)
            }
            onChange && onChange(visible)
          }}
          className={styles.action}
        >
          <img
            className={(visible ?? show) ? styles.close : styles.show}
            width="16px"
            height="16px"
            src="https://qnm.hunliji.com/FsF1lAitv934Ub8S_0ytFu9qglDn"
          />
        </div>
      </div>
    </div>
  )
}

export default GuideDrawer
